import React from 'react'

const ShippingOptionContext = React.createContext({
  shippingOption: {},
  setShippingOption: () => {},
})

export default ShippingOptionContext
